angular.module('rings-app.directives.foreign',[])
/*
* display records for scheme
*/
.directive('foreignRecords', ['observationService','$state','$rootScope','myConfig'
  ,function(observationService,$state,$rootScope,myConfig){
  return {
    restrict: 'AE',
    templateUrl : 'pages/foreign-retraps.tpl.html',
    scope : {}, 																						// isolated scope
    controllerAs : 'ForeignRecordsCtrl',
    bindToController: true,
    controller : function (){

    	// variables
    	var self = this;
    	self.records = null;
    	self.numRecords = null;
    	self.numRecordsPerPage = 50;
    	self.additionalUrl = "where=date1 > '2017-01-01' and ((station1 is '" + $rootScope.user.rings.scheme + "' or station2 is '"+ $rootScope.user.rings.scheme + "') or (owner1 is '" + $rootScope.user.User + "' or owner2 is '"+$rootScope.user.User+"'))";
      self.showForm = false;
    	self.datePicker1Opened = false;
    	self.datePicker2Opened = false;
    	self.query = {
    		dateFrom: null,
    		dateTo: null,
    		location: null,
    		species: null,
    		municipality: null,
    		ringInformation: null,
    		ringNumber: null,
    		partialMatch: false
    	}
    	self.ringInformation = [
        {"code": 1,"description": "Ring added"}
        ,{"code": 4,"description": "Ring already present"}
        ,{"code": 6,"description": "Ring removed"}
      ];

      self.order = {
        retrapType: {
          asc: false,
          desc: false
        },
        date1: {
          asc: false,
          desc: false
        },
        date2: {
          asc: false,
          desc: false
        },
        ringNumber: {
          asc: false,
          desc: false
        },
        species: {
          asc: false,
          desc: false
        },
        locality1: {
          asc: false,
          desc: false
        },
        locality2: {
          asc: false,
          desc: false
        },
        dist: {
          asc: false,
          desc: false
        },
        elapsed: {
          asc: false,
          desc: false
        },
        station1: {
          asc: false,
          desc: false
        }
      }

      // resets order of columns
      self.resetOrder = function(){
        self.order = {
          retrapType: {
            asc: false,
            desc: false
          },
          date1: {
            asc: false,
            desc: false
          },
          date2: {
            asc: false,
            desc: false
          },
          ringNumber: {
            asc: false,
            desc: false
          },
          species: {
            asc: false,
            desc: false
          },
          locality1: {
            asc: false,
            desc: false
          },
          locality2: {
            asc: false,
            desc: false
          },
          dist: {
            asc: false,
            desc: false
          },
          elapsed: {
            asc: false,
            desc: false
          },
          station1: {
            asc: false,
            desc: false
          }
        }
      }

      // adds order to url
      self.constructOrder = function(){
        var url = "&order=";
        if (self.order.date1.asc){
          return url +='date1 asc';
        } else if (self.order.date1.desc){
          return url +='date1 desc';
        } else if (self.order.date2.asc){
          return url +='date2 asc';
        } else if (self.order.date2.desc){
          return url +='date2 desc';
        } else if (self.order.species.asc){
          return url +='speciesLat asc';
        } else if (self.order.species.desc){
          return url +='speciesLat desc';
        } else if (self.order.ringNumber.asc){
          return url +='ringnumber asc';
        } else if (self.order.ringNumber.desc){
          return url +='ringnumber desc';
        } else if (self.order.dist.asc){
          return url +='dist asc';
        } else if (self.order.dist.desc){
          return url +='dist desc';
        } else if (self.order.elapsed.asc){
          return url +='elapsed asc';
        } else if (self.order.elapsed.desc){
          return url +='elapsed desc';
        } else if (self.order.station1.asc){
          return url +='station1 asc';
        } else if (self.order.station1.desc){
          return url +='station1 desc';
        } else if (self.order.locality1.asc){
          return url +='locality1 asc';
        } else if (self.order.locality1.desc){
          return url +='locality1 desc';
        } else if (self.order.locality2.asc){
          return url +='locality2 asc';
        } else if (self.order.locality2.desc){
          return url +='locality2 desc';
        }
        return "";
      }    


      self.doingResolve = false;
      self.noHistory = true;
      self.showHistoryAlert = false;

    	// load history
      self.doingResolve = true;
    	observationService.fetchUserRetraps(1,self.numRecordsPerPage,self.additionalUrl)
		    .then(function(data){
          self.doingResolve = false;
		      self.records = data.items;
		      self.numRecords = data.rowCount;
          self.noHistory = (self.numRecords === 0) ? true : false;
          if (self.noHistory) self.showHistoryAlert = true;
		    }, function(data){
		      alert("Při načítání dat došlo k chybě");
		  });

		  self.pageChanged = function(newPageNumber){
        self.doingResolve = true;
		  	observationService.fetchUserRetraps(newPageNumber,self.numRecordsPerPage,self.constructUrl())
		    .then(function(data){
          self.doingResolve = false;
		      self.records = data.items;
          self.numRecords = data.rowCount;
		    }, function(data){
		      alert("Při načítání dat došlo k chybě");
		  	});
		  }

      // path to url saved on server
      self.pdfUrl = function(path){
        var url = myConfig.apiUrl.replace('v1/','userdata/rings/reports/'+path);
        return url;
      }

		  // created additional url string to be passed to service
		  self.constructUrl = function(){
		  	var url = self.additionalUrl;
		  	// add date, if set
		  	if ((self.query.dateFrom != null && self.query.dateFrom != '')
		  		|| (self.query.dateTo != null && self.query.dateTo != '')){
		  		var dateFrom = '1000-01-01';
		  		var dateTo = '9999-12-31';
		  		if (self.query.dateFrom != null && self.query.dateFrom != ''){
		  			var dateFrom = yyyymmdd(self.query.dateFrom);
		  		}
		  		if (self.query.dateTo != null && self.query.dateTo != ''){
		  			var dateTo = yyyymmdd(self.query.dateTo);
		  		}
		  		url += " and date between '"  + dateFrom + "' and '" + dateTo + "'";
		  	}
		  	// species
		  	if (self.query.species != null){
		  		// taxonomic tree
		  		if (self.query.species.GenusId != 0){
		  			url += " and taxonid is " + self.query.species.TaxonID;
		  		} else if (self.query.species.FamilyId != 0){
		  			url += " and genusid is " + self.query.species.TaxonID;
		  		} else if (self.query.species.OrderId != 0){
		  			url += " and familyid is " + self.query.species.TaxonID;
		  		} else {
		  			url += " and orderid is " + self.query.species.TaxonID;
		  		}
		  	}
		  	// ringnumber
		  	if (self.query.ringNumber != null){
          var rn = self.query.ringNumber.replace(/\s/g,'');
          url += " and ringnumber is '" + rn + "'";
          //var fullrn = fullRingNumber(rn);
          /*if (fullrn == rn || fullrn === null){
            url += " and ringnumber is '" + rn + "'";
          } else {
            url += " and (ringnumber is '" + rn + "' or ringnumber is '" + fullrn + "')";
          }*/
		  	}
        // add order only of not already present
        if (url.indexOf('&order') === -1){
          url += self.constructOrder();
        }
		  	return url;
		  }

      self.changeOrder = function(type){
        var asc = self.order[type].asc;
        self.resetOrder();
        if (asc){
          self.order[type].desc = true;
        } else {
          self.order[type].asc = true;
        }
        self.getHistory();
      }

		  // toggle visibility of search form
		  self.toggleFormVisibility = function(){
		  	self.showForm = !self.showForm;
		  }

		  // reset all form options
		  self.resetForm = function(){
		  	self.query = {
	    		dateFrom: null,
	    		dateTo: null,
	    		location: null,
	    		species: null,
	    		municipality: null,
	    		ringInformation: null,
	    		ringNumber: null,
	    		partialMatch: false
	    	}
	    	// reset autocompleter
	    	$rootScope.$broadcast('angucomplete-alt:clearInput');
		  }

		  self.openDatePicker = function(val){
		  	 if (val == 1){
		  	 	self.datePicker1Opened = true;
		  	 } else if (val == 2){
		  	 	self.datePicker2Opened = true;
		  	 }
		  }

		  // when autocompleter option for species is selected, update model
    	this.updateSpecies = function (selectedValue) {
        // if the user clears the input box        
        if (!selectedValue) {
            self.query.species = null;
            return;
        }
        self.query.species = selectedValue.originalObject; 
    	};

    	// when autocompleter option for municipality is selected, update model
    	this.updateMunicipality = function (selectedValue) {
    		if (!selectedValue) {
            self.query.municipality = null;
            return;
        }
        if (selectedValue) {
        	self.query.municipality = selectedValue.originalObject.kodcobe;
        }
    	};

		  // get history
		  self.getHistory = function(){
		  	self.doingResolve = true;
        var url = self.constructUrl();
        observationService.fetchUserRetraps(1,self.numRecordsPerPage,url)
          .then(function(data){
            self.doingResolve = false;
            self.records = data.items;
            self.numRecords = data.rowCount;
            self.noHistory = (self.numRecords === 0) ? true : false;
            if (self.noHistory) self.showHistoryAlert = true;
          }, function(data){
            alert("Při načítání dat došlo k chybě");
        });
		  }
 
    }
  }
}])
.directive('foreignObservation', ['locationService','observationService','codebookService','$rootScope','$cookieStore','$state','$location','$anchorScroll','$filter','$timeout',
                                                        function(locationService,observationService,codebookService,$rootScope,$cookieStore,$state,$location,$anchorScroll,$filter,$timeout){
  return {
    restrict: 'AE',
    templateUrl : 'pages/foreign-observation.tpl.html',
    scope : { },                                                                                        // isolated scope
    controllerAs : 'ForeignObservationCtrl',
    bindToController: true,
    controller : function ($scope){

        // variables
        var self = this;
        //self.id = null,
        self.date = null;
        self.maxDate = new Date();
        self.datePickerOpened = false;
        self.time = null;
        self.note = null;
        self.coobservers = null;
        self.locality = new Locality();
        self.detail = new Observation('CZP');
        self.detail.ringingScheme = 'CZP';
        self.country = null;
        self.showAlert = false;
        self.showCircumstancesDetail = false;

        self.supportedFormatsTpl = "Supported formats:<ul><li>48.255757N, 17.597398E</li><li>N 50&deg;2.96520&rsquo;, E 14&deg;30.58850&rsquo;</li><li>39º17'00''N 03º14'00''W</li><li>39 41 45N 03 14 00W</li><li>50&deg;4&rsquo;49.008&rdquo;N, 14&deg;24&rsquo;37.656&rdquo;E</li></ul>"

        // map options
        self.mapOption = {
          lat: 49.85,
          lng: 15.50,
          zoom: 6
        }
        self.ringInformation = [
          {"code": 1,"description": "Ringing"}
          ,{"code": 4,"description": "Retrap"}
          ,{"code": 6,"description": "Remove ring"}
        ];

        self.schemes = ['CZP',$rootScope.user.rings.scheme];

        // load codebook
        codebookService.fetchCodebook()
          .then(function(data){
            self.codebook = data;
            self.codebook.time = [''];
            for (var i = 1; i<24; i++){
                var output = (i < 10 ? '0' : '') + i + ':00';
                self.codebook.time.push(output);
            }
          }, function(data){
            alert(data);
          });

        this.map = {
          events: {
          zoom_changed: function (mapModel, eventName, originalEventArgs) {
            var zoomLevel = (mapModel.getZoom());
            self.crdsToText();
            //$cookieStore.put('zoomLevel', zoomLevel);
          },
          center_changed: function(mapModel, eventName, originalEventArgs) {
            var mapCenter = (mapModel.getCenter());
            self.crdsToText();
          },
          click: function (mapModel, eventName, originalEventArgs) {
            if (self.mapOption.zoom < 10){
                return;
            } else {
                var e = originalEventArgs[0];
                var lat = e.latLng.lat(),
                  lon = e.latLng.lng();
                self.locality.coords.latitude = lat;
                self.locality.coords.longitude = lon;
                self.crdsToText();
                $scope.$apply();
              }            
            }
          }
        };

        this.crdsToText = function(){
          if (typeof self.locality.coords.longitude === 'undefined' || self.locality.coords.longitude == null){
            self.crdsText = null;
          } else {
            self.crdsText = parseFloat(self.locality.coords.longitude).toFixed(5) + ', ' + parseFloat(self.locality.coords.latitude).toFixed(5);
          }           
        }

        this.updateCrds = function(){
          if (self.locality.crdsText == null || self.locality.crdsText == ''){
            self.locality.err = false;
            return;
          }
          // example 48.255757N, 17.597398E
          var regexPattern1 = /^([0-9]{1,2}\.[0-9]*)[N,S]?, ([0-9]{1,2}\.[0-9]*)[E,W]?$/i;
          // example 50°4'49.008"N, 14°24'37.656"E
          var regexPattern2 = /^([0-9]{1,2})°([0-9]{1,2})'([0-9]{1,2}\.?[0-9]+?)"[N,S]?, ([0-9]{1,2})°([0-9]{1,2})'([0-9]{1,2}\.?[0-9]+?)"[E,W]?$/i;
          // example N 50°2.96520', E 14°30.58850'
          var regexPattern3 = /^[N,S] ([0-9]{1,2})°([0-9]{1,2}\.[0-9]+)', [E,W] ([0-9]{1,2})°([0-9]{1,2}\.[0-9]+)'$/i
          // example 39º17'00''N 03º14'00''W
          var regexPattern4 = /^([0-9]{1,2})º([0-9]{1,2})'([0-9]{2})''[N,S] ([0-9]{1,2})º([0-9]{1,2})'([0-9]{2})''[E,W]$/i
          // example 39 17 00N 03 14 00W
          var regexPattern5 = /^([0-9]{1,2}) ([0-9]{1,2}) ([0-9]{1,2})[N,S] ([0-9]{1,2}) ([0-9]{1,2}) ([0-9]{1,2})[E,W]$/i
          if (regexPattern1.test(self.locality.crdsText)){
            var match = regexPattern1.exec(self.locality.crdsText);
            self.locality.coords.longitude = match[2];
            if (self.locality.crdsText.indexOf('W') !== -1){
              self.locality.coords.longitude = (-1)*self.locality.coords.longitude;
            }
            self.locality.coords.latitude = match[1];
             if (self.locality.crdsText.indexOf('S') !== -1){
              self.locality.coords.latitude = (-1)*self.locality.coords.latitude;
            }
            self.locality.err = false;
          } else if (regexPattern2.test(self.locality.crdsText)){
            var match = regexPattern2.exec(self.locality.crdsText);
            degreeN = match[1];
            degreeE = match[4];
            minuteN = match[2];
            minuteE = match[5];
            secondN = match[3];
            secondE = match[6];
            var lat = parseFloat(degreeN) + parseFloat(minuteN)/60 + parseFloat(secondN)/3600;
            if (self.locality.crdsText.indexOf('S') !== -1){
              lat = (-1)*lat
            }
            var lon = parseFloat(degreeE) + parseFloat(minuteE)/60 + parseFloat(secondE)/3600;
            if (self.locality.crdsText.indexOf('W') !== -1){
              lon = (-1)*lon
            }
            self.locality.coords.longitude =lon;
            self.locality.coords.latitude = lat;
            self.locality.err = false;
          } else if (regexPattern3.test(self.locality.crdsText)){
            var match = regexPattern3.exec(self.locality.crdsText);
            degreeN = match[1];
            degreeE = match[3];
            minuteN = match[2];
            minuteE = match[4];
            var lat = parseFloat(degreeN) + parseFloat(minuteN)/60;
            if (self.locality.crdsText.indexOf('S') !== -1){
              lat = (-1)*lat
            }
            var lon = parseFloat(degreeE) + parseFloat(minuteE)/60;
            if (self.locality.crdsText.indexOf('W') !== -1){
              lon = (-1)*lon
            }
            self.locality.coords.longitude =lon;
            self.locality.coords.latitude = lat;
            self.locality.err = false;
          } else if (regexPattern4.test(self.locality.crdsText)){
            var match = regexPattern4.exec(self.locality.crdsText);
            degreeN = match[1];
            degreeE = match[4];
            minuteN = match[2];
            minuteE = match[5];
            secondN = match[3];
            secondE = match[6];
            var lat = parseFloat(degreeN) + parseFloat(minuteN)/60 + parseFloat(secondN)/3600;
            if (self.locality.crdsText.indexOf('S') !== -1){
              lat = (-1)*lat
            }
            var lon = parseFloat(degreeE) + parseFloat(minuteE)/60 + parseFloat(secondE)/3600;
            if (self.locality.crdsText.indexOf('E') !== -1){
              lon = (-1)*lon
            }
            self.locality.coords.longitude =(-1)*lon;
            self.locality.coords.latitude = lat;
            self.locality.err = false;
          } else if (regexPattern5.test(self.locality.crdsText)){
            var match = regexPattern5.exec(self.locality.crdsText);
            degreeN = match[1];
            degreeE = match[4];
            minuteN = match[2];
            minuteE = match[5];
            secondN = match[3];
            secondE = match[6];
            var lat = parseFloat(degreeN) + parseFloat(minuteN)/60 + parseFloat(secondN)/3600;
            if (self.locality.crdsText.indexOf('S') !== -1){
              lat = (-1)*lat
            }
            var lon = parseFloat(degreeE) + parseFloat(minuteE)/60 + parseFloat(secondE)/3600;
            if (self.locality.crdsText.indexOf('E') !== -1){
              lon = (-1)*lon
            }
            self.locality.coords.longitude =(-1)*lon;
            self.locality.coords.latitude = lat;
            self.locality.err = false;
          } else {
            alert('Zadaný formát souřadnic se nepodařilo rozpoznat');
            //self.crdsError = true;
            self.locality.err = true;
          }
          if (!self.locality.err){
            self.mapOption.lat = self.locality.coords.latitude;
            self.mapOption.lng = self.locality.coords.longitude;
            self.mapOption.zoom = 14;
          }
          $timeout(function() {
            $rootScope.$broadcast('locationUpdated');
          }, 100);
        }

        // when country is selected, update place code
        this.updatePlaceCode = function(){
          self.detail.placecode = self.country.Code;
        }

        // when autocompleter option is selected, update model
        this.updateSpecies = function (selectedValue) {
          // if the user clears the input box        
          if (!selectedValue) {
              self.detail.species = {TaxonID: null,Name:null,Fullname:null,isWader:null};
              return;
          }
          self.detail.species = selectedValue.originalObject; 
        };

        // additional marks functions
        // after click on additional mark set delete it
        self.removeAdditionalMark = function(mark) {
          if (confirm('Opravdu chcete smazat identifikační značku?')) {
            //delete self.marks[mark.uuid];
            self.detail.additionalMarks = self.detail.additionalMarks.filter(function (el) {
              return el !== mark;
            });
          }
        }

        // if type is 'new ringing', ringingscheme is always code of scheme
        this.changeRingingInformation = function(mark) {
          if (mark.ringInformation == 1) {
            mark.ringingScheme=$rootScope.user.rings.scheme;
          }
        }

        // return class for color - required based on markType
        this.colorRequired = function(mark){
          if(typeof mark === 'undefined'){
            return null;
          } else if (['B0','C0','D0','H0'].indexOf(mark.markType) != -1){
            return 'required';
          } else {
            return null;
          }
        }

        // when circumstances are changed, check, if parent code starts with P. if not, set it as circumstances
        this.changeCircumstances = function(){
          if (self.detail.circumstancesParent.startsWith('P') != true){
            self.showCircumstancesDetail = false;
            self.detail.circumstances = self.detail.circumstancesParent;
          } else {
          self.showCircumstancesDetail = true;
        }
        }

        // add identification mark
        self.addIdentificationMark = function() {
          self.detail.additionalMarks.push(new Mark());      
        }

        // filter - return true if the species is wader, otherwise return false
        self.filterEmpty = function() {
          return function( item ) {
            return item.NameEng.length > 1;
          };
        };

        // functions - validation
        this.validate = function(){
          // validate ObsList
          // validate date
          if (self.date == null){           // date not set
            alert($filter('translate')("DATE.NOT.SET"));
            return false;
          } else {
            var dt = new Date(self.date);   // date in incorrect format
            if ( Object.prototype.toString.call(dt) === "[object Date]" 
                && isNaN(dt.getTime())){
              alert($filter('translate')("DATE.NOT.SET"));
              return false;
            } else {
              var today = new Date();       // date in future
              if (dt > today){
                alert($filter('translate')("DATE.FUTURE"));
                return false;
              }
            }         
          }
          // validate municipality
          if (self.country == null 
              ||typeof self.country === 'undefined' 
              || self.country.length == 0){
            alert($filter('translate')("COUNTRY.NOT.SET"));
            return false;
          }
          // validate coordinates
          if ( self.locality.err
              || typeof self.locality.coords === 'undefined'
              || self.locality.coords == null
              || !isNumber(self.locality.coords.latitude)
              || !isNumber(self.locality.coords.longitude)){
            alert($filter('translate')("CRDS.NOT.SET"));
            return false;
          }
          // validate CZ
          if (self.locality.Country
              && self.locality.Country!='CZ'){
            return false;
          }
          // obsList OK

          // validate obsitem
          // identification method
          if (self.detail.markType == null){
            alert($filter('translate')("MARKTYPE.NOT.SET"));
            return false;
          }
          // ring number
          if (self.detail.ringNumber1 == null || self.detail.ringNumber1.length == 0){
            alert($filter('translate')("RINGNUMBER.NOT.SET"));
            return false;
          }
          // validate mark color of additional marks
          for (var i = 0; i < self.detail.additionalMarks.length; i++){
            var mark = self.detail.additionalMarks[i];
            if (['B0','C0','D0','H0'].indexOf(mark.markType) != -1
              && mark.markColor == null){
              alert($filter('translate')("MARKCOLOR.NOT.SET"));
              return false;
            } 
          }
          // sex
          if (self.detail.sex == null ){
            alert($filter('translate')("SEX.NOT.SET"));
            return false;
          }
          // validate species
          if (self.detail.species == null || self.detail.species.TaxonID == null){
            alert($filter('translate')("SPECIES.NOT.SET"));
            return false;
          }
          // validate circumstances
          if (self.detail.circumstances == null){
            alert($filter('translate')("CIRCUMSTANCES.NOT.SET"));
            return false;
          }

          // biometrics - validated by form itself (validation inside angular)

          // qualitative fields
          var alula = [self.detail.alula.v1,self.detail.alula.v2,self.detail.alula.v3];
          // is any of the values not null?
          if (alula.indexOf(null) != -1){
            var allNull = true;
            for (i=0;i<alula.length;++i){
              if (alula[i] == null){
                if (!allNull){
                  alert($filter('translate')("ALULA.NOT.SET"));
                  return false;
                }             
              } else {
                allNull = false;
              }
            }
          }
          // primary moult
          var pm = [self.detail.primaryMoult.v1,self.detail.primaryMoult.v2,
                    self.detail.primaryMoult.v3,self.detail.primaryMoult.v4,
                    self.detail.primaryMoult.v5,self.detail.primaryMoult.v6,
                    self.detail.primaryMoult.v7,self.detail.primaryMoult.v8,
                    self.detail.primaryMoult.v9,self.detail.primaryMoult.v10];
          // is any of the values not null?
          if (pm.indexOf(null) != -1){
            var allNull = true;
            for (i=0;i<pm.length;++i){
              if (pm[i] == null){
                if (!allNull){
                  alert($filter('translate')("PRIMARYMOULT.NOT.SET"));
                  return false;
                }             
              } else {
                allNull = false;
              }
            }
          }

          return true;
        }

        this.reset = function(){
          self.date = null;
          self.datePickerOpened = false;
          self.time = null;
          self.note = null;
          self.locality = new Locality();
          self.crdsText = null;
          self.detail = new Observation('CZP');
          self.detail.ringingScheme = 'CZP';
          self.country = null;
        }

        // save to DB
        this.saveDetail = function(){
          if (self.validate()){
            var dataToSend = self.detail;
            dataToSend['user'] = $rootScope.user;   
            dataToSend['date'] = self.date;
            dataToSend['time'] = self.time;
            dataToSend['lat'] = self.locality.coords.latitude;
            dataToSend['lon'] = self.locality.coords.longitude;
            dataToSend['coobservers'] = self.coobservers;

            self.send(dataToSend);
          }
        }

        // send method
        this.send = function(dataToSend){
          var result = observationService.sendForeignItem(dataToSend).then(
            function(result) {
              if (typeof result.error !== 'undefined'){
                alert($filter('translate')("SAVE.ERROR"));
              } else {
                self.reset();
                self.showAlert = true;
                // scroll to message
                $location.hash('succesMessage');
                $anchorScroll();
              }
            });
        }


    }
  }
}]);